import React from 'react';
import { LazySection } from './LazySection';
export function Oferta() {
  return <LazySection id="oferta" className="bg-cream !py-[80px] md:!py-[100px]" data-id="element-264">
      <div className="container-wide" data-id="element-265">
        <div className="text-center mb-10" data-id="element-266">
          <span className="eyebrow" data-id="element-267">Elegí tu camino</span>
          <h2 className="text-[clamp(34px,5vw,52px)] mb-4" data-id="element-268">
            Empezá hoy a descubrir <em data-id="element-269">de dónde viene todo esto</em>
          </h2>
          <p className="text-ink-soft text-[17px] max-w-[620px] mx-auto mb-6" data-id="element-270">
            Acceso inmediato. Sin fechas. Sin grupos. Tuyo para siempre.
          </p>
          <span className="inline-block text-ink-soft text-[14px] bg-gold/10 px-5 py-3 rounded-full italic" data-id="element-271">
            💡 Una sesión de terapia en Argentina cuesta entre $20.000 y
            $40.000. Este sistema, al precio de una consulta, te da herramientas
            para trabajar durante meses.
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[920px] mx-auto" data-id="element-272">
          {/* Plan Esencial */}
          <div className="bg-white rounded-[24px] p-8 md:px-9 md:py-10 border border-border relative flex flex-col" data-id="element-273">
            <h3 className="text-[24px] mb-1.5 font-serif" data-id="element-274">Acceso Esencial</h3>
            <p className="text-[13px] text-ink-soft mb-6" data-id="element-275">
              Para empezar a trazar el{' '}
              <span className="highlight-keyword" data-id="element-276">origen</span>
            </p>

            <span className="font-serif text-[18px] text-ink/40 line-through mb-0.5 block" data-id="element-277">
              $29.990
            </span>
            <div className="font-serif text-[44px] font-medium leading-none mb-1" data-id="element-278">
              $19.990
            </div>
            <div className="text-[12px] text-ink-soft tracking-[0.08em] mb-6" data-id="element-279">
              ARS · PAGO ÚNICO · ACCESO INMEDIATO
            </div>

            <ul className="list-none mb-7 flex flex-col gap-1 flex-grow" data-id="element-280">
              {['Módulo 1 · El Mapa (Genograma)', 'Módulo 2 · La Herencia (Anamnesis)', 'Módulo 3 · La Separación', 'Módulo 4 · La Liberación (Cartas)', 'Módulo 5 · La Integración (Diario)', 'Módulo 6 · La Continuidad'].map((item, i) => <li key={i} className="py-1.5 pl-[26px] text-[14px] relative leading-[1.45]" data-id="element-281">
                  <span className="absolute left-0 top-1.5 text-gold-dark font-semibold" data-id="element-282">
                    ✓
                  </span>
                  {item}
                </li>)}
            </ul>

            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNB8kX9bOq8QdQOiOFYpqy1/es-ar?_r=AQABGsHkzY998w9u6VIq0cHFmFe2DF0gJLpJ6aHDy0v2y_M&preview_theme_id=186487341342" className="block w-full text-center p-4 rounded-full text-[14px] font-semibold no-underline transition-all duration-200 cursor-pointer border-none tracking-[0.02em] bg-cream text-ink border-[1.5px] border-solid border-ink hover:bg-ink hover:text-cream mt-auto" data-id="element-283">
              Empezar a entender →
            </a>
            <p className="text-center text-[12px] mt-3.5 text-ink-soft" data-id="element-284">
              🔒 Pago seguro con Mercado Pago
            </p>
          </div>

          {/* Plan Completo */}
          <div className="bg-ink text-cream rounded-[24px] p-8 md:px-9 md:py-10 border-2 border-gold relative md:scale-[1.03] shadow-deep flex flex-col" data-id="element-285">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gold text-ink px-4 py-1.5 rounded-full text-[11px] font-bold tracking-[0.12em] uppercase whitespace-nowrap" data-id="element-286">
              ★ El más elegido
            </div>

            <h3 className="text-[24px] mb-1.5 font-serif text-cream" data-id="element-287">
              Sistema Completo
            </h3>
            <p className="text-[13px] text-cream/70 mb-6" data-id="element-288">
              Para entender y{' '}
              <span className="highlight-keyword-light" data-id="element-289">liberar</span> a fondo
            </p>

            <span className="font-serif text-[18px] text-cream/40 line-through mb-0.5 block" data-id="element-290">
              $44.990
            </span>
            <div className="font-serif text-[44px] font-medium leading-none mb-1" data-id="element-291">
              $29.990
            </div>
            <div className="text-[12px] text-cream/70 tracking-[0.08em] mb-6" data-id="element-292">
              ARS · PAGO ÚNICO · ACCESO INMEDIATO
            </div>

            <ul className="list-none mb-7 flex flex-col gap-1 flex-grow" data-id="element-293">
              {['Los 6 módulos del sistema, completos', 'Biblioteca de meditaciones guiadas', 'Protocolos de protección energética', 'Hojas de seguimiento del proceso'].map((item, i) => <li key={i} className="py-1.5 pl-[26px] text-[14px] relative leading-[1.45]" data-id="element-294">
                  <span className="absolute left-0 top-1.5 text-gold-light font-semibold" data-id="element-295">
                    ✓
                  </span>
                  {item}
                </li>)}

              <li className="font-serif italic text-gold-light text-[13px] !pt-3 !pb-1 border-t border-dashed border-gold/30 mt-2.5 !pl-0 text-center" data-id="element-296">
                — 4 bonos exclusivos incluidos —
              </li>

              {['🌸 Protocolo de Linaje Materno', '🌿 Protocolo de Linaje Paterno', '👧 Protocolo de la Voz Crítica', '📓 Diario Guiado de 12 Meses'].map((item, i) => <li key={`bonus-${i}`} className="py-1.5 pl-[26px] text-[14px] relative leading-[1.45]" data-id="element-297">
                  <span className="absolute left-0 top-1.5 text-gold-light font-semibold" data-id="element-298">
                    ✓
                  </span>
                  {item}
                </li>)}
            </ul>

            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNB8kcghSL4J4gLE9bfSljF/es-ar?_r=AQABY9vu39JZ03XZNVfeI0RZdrnBvs1la7xma74CW_r41Jo&preview_theme_id=186487341342" className="block w-full text-center p-4 rounded-full text-[14px] font-semibold no-underline transition-all duration-200 cursor-pointer border-none tracking-[0.02em] bg-gold text-ink hover:bg-gold-light hover:-translate-y-0.5 mt-auto" data-id="element-299">
              Quiero liberar esto de verdad →
            </a>
            <p className="text-center text-[12px] mt-3.5 text-cream/60" data-id="element-300">
              🔒 Mercado Pago · Acceso inmediato · 7 días de garantía
            </p>
          </div>
        </div>
      </div>
    </LazySection>;
}